import { defineMessages } from 'react-intl';

type MessageKeys =
	| 'deleteSpaceTitle'
	| 'modalBody'
	| 'cancelButtonLabel'
	| 'deleteButtonLabel'
	| 'genericErrorMessage';

const message: Record<MessageKeys, { id: string; defaultMessage: string; description?: string }> =
	defineMessages({
		deleteSpaceTitle: {
			id: 'ai-mate.rovo-spaces.delete-space-modal.title',
			defaultMessage: 'Delete "{name}"?',
			description:
				'Title of the confirmation modal shown when a user tries to delete a Rovo space. {name} is the space name.',
		},
		modalBody: {
			id: 'ai-mate.rovo-spaces.delete-space-modal.body',
			defaultMessage:
				'This Rovo space, all its settings, and conversations will be permanently deleted.',
			description:
				'Body text of the delete Rovo space confirmation modal explaining what will be deleted.',
		},
		cancelButtonLabel: {
			id: 'ai-mate.rovo-spaces.delete-space-modal.cancel',
			defaultMessage: 'Cancel',
			description: 'Label for the cancel button in the delete space confirmation modal.',
		},
		deleteButtonLabel: {
			id: 'ai-mate.rovo-spaces.delete-space-modal.delete',
			defaultMessage: 'Delete',
			description: 'Label for the confirm delete button in the delete space confirmation modal.',
		},
		genericErrorMessage: {
			id: 'ai-mate.rovo-spaces.delete-space-modal.error',
			defaultMessage: 'Something went wrong. Please try again.',
			description: 'Generic error message shown when the space deletion fails.',
		},
	});

export default message;
